export default __webpack_public_path__ + "static/media/logo192.fd9f2937.png";